import Vue from 'vue'
import debounce from 'lodash/debounce'

import beforeTable from './advanced-search-before-table'
Vue.component(beforeTable.name, beforeTable)

export default {
    slots() {
        return [
            {
                slot: "before-table",
                component: beforeTable.name,
                condition(attrs) {
                    if( ! this.displayAdvancedSearch ) {
                        return false
                    }

                    return true
                }
            }
        ]
    },
    mixins() {
        return {
            props: {
                displayAdvancedSearch: {
                    type: Boolean,
                    default: true
                },
                advancedSearch: {
                    type: Object,
                    default: () => ({})
                },
                advancedSearchFilters: {
                    type: Array,
                    default: () => []
                },
                advancedSearchEvents: {
                    type: Object,
                    default: () => ({})
                }
            },
            data() {
                return {
                    conditionsState: {}
                }
            },
            created() {
                Vue.set(this.conditionsState, 'advanced-filters', {})

                let debounced_onChange = debounce(function(conditions) {
                    this.$emit('change', conditions)
                }.bind(this), 100)

                this.$off('change-internal').$on('change-internal', debounced_onChange)
            }
        }
    }
}
